export default "__VITE_ASSET__DsMq2auh__"